import { observer } from 'mobx-react-lite'
import { withPrefix } from 'gatsby'
import React from 'react'
import { useEffect } from 'react';
import { useStore } from '../../../../../../hooks/useStore'

const MapBackground = observer(({ready}) => {
    const {uiStore: {home__map__activeCity, preloadMapImages, isMobile}} = useStore();
    useEffect(() => {
        // preload images
        if (isMobile) return
        preloadMapImages();
    }, []);
    let src;
    if (home__map__activeCity === "All cities") return <MapBackgroundOverview ready={ready}/>
     
    return <MapBackroundCities />

    
});

const MapBackgroundOverview = observer(({ready}) => {
    const {uiStore: {home__map__transitionDirection, home__map__showClouds}} = useStore();

    return (
        <div className={`mp-bg ${ready ? "ready" : ""} ${home__map__showClouds ? "clouds" : "no-clouds"} ${home__map__transitionDirection === "in" ? "to-city" : "from-city"}`}>
            <img src={withPrefix('/images/map/entire-map-2x.webp')} alt="" />
            <OverviewCloudLayer/>
            <OverviewBirdLayer/>
            <style jsx>{`
                div {
                    position: absolute;
                    top: 0;
                    left: 0;
                    height: 100%;
                    width: 100%;
                    overflow: hidden;
                    contain: strict;
                }

                img {
                    transform: scale(1);
                    // opacity: 0;
                }

                .mp-bg {
                    opacity: 0;
                }
                
                .ready {
                    opacity: 1;
                    transition: opacity 2.5s ease;

                }

                .ready img{
                    transform: scale(1.08);
                    transition: transform 2.5s cubic-bezier(0.37, 0, 0.63, 1);
                }
                

                .to-city.clouds {
                    opacity: 0;
                    transition: opacity 1.2s linear 1.1s;
                }

                .to-city.clouds img{
                    transform: scale(1.35);
                    transition: transform 2.25s ease-in;
                }

                .clouds.from-city {
                    opacity: 0;
                }

                
                .clouds.from-city img{
                    transform: scale(1.3);
                }

                .no-clouds.from-city {
                    opacity: 1;
                    transition: opacity 1.5s linear;
                }

                .no-clouds.from-city img{
                    transform: scale(1.08);
                    transition: transform 2.2s ease-out;
                }

                @media (max-width: 769px), (pointer: coarse) {
                    img {
                        display: none;
                    }
                }

            `}</style>
        </div>
    )
});

const MapBackroundCities = observer(() => {
    const {uiStore: {mapOffsetPx: {x, y}, home__map__activeCity, home__map__transitionDirection, home__map__showClouds, windowHeight, windowWidth}} = useStore();

    let src;
    switch(home__map__activeCity) {
        case "Philadelphia":
            src = '/images/map/philadelphia-2x.webp';
            break;
        case "LA":
            src = '/images/map/la-alt-2x.webp';
            break;
        case "Atlanta":
            src = '/images/map/atlanta-2x.webp';
            break;
        case "Chicago":
            src = '/images/map/chicago-2x.webp';
            break;
        case "Buffalo":
            src = '/images/map/buffalo-2x.webp';
            break;
        case "Detroit":
            src = '/images/map/detroit-2x.webp';
            break;
        default:
            return null;
    }
    const style = {
        transform: `translate3d(${-x}px, ${
          y}px, 0)`,
    }
    

    return (
        <div className='bg-cities'>  
            <div style={style}>
                <img className={`${home__map__transitionDirection} ${home__map__showClouds ? "clouds" : "no-clouds"}`} src={withPrefix(src)} alt="" />
            </div>
            <style jsx>{`
                    .bg-cities {
                        overflow:hidden;
                        contain: strict;
                    }

                    div {
                        position: absolute;
                        top: 0;
                        left: 0;
                        height: 100%;
                        width: 100%;
                        // overflow: hidden;
                    }

                    img {
                        transform: scale(1);
                        opacity: 0;
                    }

                    .no-clouds.in {
                        opacity: 1;
                        transform: scale(1.1);
                        transition: opacity 1.5s linear, transform 2.2s ease-out;
                    }

                    .clouds.out {
                        opacity: 0;
                        transform: scale(1);
                        transition: opacity 1.2s linear 1s, transform 2.2s ease-in;
                    }

                `}</style>
        </div>
    )
})

// const MapBackgroundCity = () => {
//     return (

//     )
// }


const OverviewCloudLayer = observer(() => {
    const {uiStore: {home__map__transitionDirection, home__map__showClouds}} = useStore();

    return (
        <div className={`overview-cloud-layer ${home__map__showClouds ? "clouds" : "no-clouds"} ${home__map__transitionDirection}`}>
            <img className="corners" src={withPrefix('/images/map/overview-cloud-layer.webp')} alt="" />


            <img className="cloud c-1" src={withPrefix('/images/map/cloud-01.webp')} alt="" />
            <img className="cloud c-2" src={withPrefix('/images/map/cloud-02.webp')} alt="" />
            <img className="cloud c-3" src={withPrefix('/images/map/cloud-03.webp')} alt="" />
            <img className="cloud c-4" src={withPrefix('/images/map/cloud-04.webp')} alt="" />


            <style jsx>{`
                .corners{
                    position: absolute; 
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    width: 100.5%;
                    height: 100.5%;
                    max-width: none;
                }

                .overview-cloud-layer {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    contain: strict;
                    pointer-events: none;
                }
                

                .overview-cloud-layer.clouds.in {
                    transform: scale(1.75);
                    transition: transform 2.2s ease-in;
                }

                
                .overview-cloud-layer.clouds.out{
                    transform: scale(1.75);
                }

                .overview-cloud-layer.no-clouds.out{
                    transform: scale(1);
                    transition: transform 2.2s ease-out;
                }

                .cloud {
                    position: absolute; 
                    top: 0;
                    left: 0;
                }

                .c-1 {
                    top: 10%;
                    left: 30%;
                    width: 15%;
                    animation: shift 24s linear infinite alternate;
                    animation-delay: -434.15s;
                }

                .c-2 {
                    top: 50%;
                    left: 60%;

                    width: 22%;
                    animation: shift 24s linear infinite alternate;
                    animation-delay: -224.1s;

                }

                .c-3 {
                    top: 70%;
                    left: 60%;
                    width: 18%;
                    animation: shift 24s linear infinite alternate;
                    animation-delay: -13.81s;

                }
                .c-4 {
                    top: 40%;
                    width: 20%;
                    animation: shift 24s linear infinite alternate;
                    animation-delay: -173.21s;

                }

                @keyframes shift {
                    from {
                        transform: translateX(100%)
                    }
                    to {
                        transform: translateX(0%)
                    }
                }
            `}</style>
        </div>
    )
});

const OverviewBirdLayer = observer(() => {
    const {uiStore: {home__map__transitionDirection, home__map__showClouds}} = useStore();

    return (
        
        <div className={`overview-cloud-layer ${home__map__showClouds ? "clouds" : "no-clouds"} ${home__map__transitionDirection}`}>
            <div className="birds">
                <img className="bird b-1" src={withPrefix('/images/map/bird-01.webp')} alt="" />
                <img className="bird b-2" src={withPrefix('/images/map/bird-02.webp')} alt="" />
                <img className="bird b-3" src={withPrefix('/images/map/bird-03.webp')} alt="" />
            </div>

            <style jsx>{`
                .overview-cloud-layer {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    pointer-events: none;
                }

                .overview-cloud-layer.clouds.in {
                    transform: scale(1.4);
                    transition: transform 2.2s ease-in;
                }

                
                .overview-cloud-layer.clouds.out{
                    transform: scale(1.4);
                }

                .overview-cloud-layer.no-clouds.out{
                    transform: scale(1);
                    transition: transform 2.2s ease-out;
                }


                img {
                    height: 50px;
                } 

                .birds {
                    position: absolute;
                    left: 44%;
                    bottom: 10%;
                    width: 200px;
                    height: 150px;
                }

                .bird {
                    position: absolute;
                }

                .b-1 {
                    top: 70px;
                    left: 20px;
                    animation: float 10s ease-in-out infinite;
                }

                .b-2 {
                    top: 110px;
                    left: 94px;
                    animation: float 7s ease-in-out infinite;
                    animation-delay: -16s;

                }

                .b-3 {
                    top: 40px;
                    height: 30px;
                    right: 45px;
                    animation: float 12s ease-in-out infinite;
                    animation-delay: -123.23s;
                }


                @keyframes float {
                    0% {
                        transform: translatey(0px);
                    }
                    50% {
                        transform: translatey(-10px);
                    }
                    100% {
                        transform: translatey(0px);
                    }
                }
                            
            `}</style>
        </div>
    )
})


export default MapBackground